module.exports = __webpack_public_path__ + "assets/img/漏斗图.f861d2e3.png";